import { useGetTeamsQuery, useGetTeamByNameQuery } from "../store/api/mlbApi";

export const useTeams = (paginationParams = {}) => {
  const {
    data: teamsResponse,
    isLoading,
    error,
    refetch,
  } = useGetTeamsQuery(paginationParams);

  return {
    teams: teamsResponse?.teams || [],
    totalResults: teamsResponse?.totalResults || 0,
    currentPage: teamsResponse?.currentPage || 1,
    pageSize: teamsResponse?.pageSize || 25,
    totalPages: teamsResponse?.totalPages || 0,
    isLoading,
    error,
    refetch,
    // Helper function to filter teams (client-side filtering for search)
    getFilteredTeams: (searchTerm = "") => {
      const teams = teamsResponse?.teams || [];
      if (!searchTerm) return teams;
      return teams.filter((team) =>
        team._id?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    },
    // Helper function to get team by name
    getTeamByName: (teamName) => {
      const teams = teamsResponse?.teams || [];
      return teams.find((team) => team._id === teamName);
    },
    // Helper function to get total number of teams
    getTotalTeams: () => {
      return teamsResponse?.totalResults || 0;
    },
  };
};

export const useTeamDetails = (teamName) => {
  const { data, isLoading, error, refetch } = useGetTeamByNameQuery(teamName, {
    skip: !teamName,
  });

  return {
    team: data?.team,
    isLoading,
    error,
    refetch,
  };
};
